import { faker } from '@faker-js/faker';

import {
  BroadsignFrame,
  FormatSize,
  LinkedAssetFrame,
  Tag,
  VenueType,
} from 'types/detailsEntityType';

export const generateFrameName = (): string => {
  const placeName = faker.location.streetAddress();
  const area = faker.location.secondaryAddress();
  const city = faker.location.city();

  return `${placeName}, ${area}, ${city}`;
};

export const broadsignFrame = (): BroadsignFrame => ({
  broadsignFrameId: faker.string.numeric(9),
  displayUnitId: faker.string.numeric(9),
});

export const linkedAssetFrame = (name: string): LinkedAssetFrame => ({
  spaceId: faker.string.numeric(9),
  name: name,
  broadsignFrames: [broadsignFrame(), broadsignFrame(), broadsignFrame()],
});

const identifiableEntity = (entityType: string) => {
  const id = faker.string.numeric(2);
  return {
    id: id,
    name: `${entityType} ${id}`,
  };
};

export const formatSize = (): FormatSize => {
  return identifiableEntity('Format Size');
};

export const venueType = (): VenueType => {
  return identifiableEntity('Venue Type');
};

export const tag = (): Tag => {
  return identifiableEntity('Tag');
};
